export const urls = {
  default: "http://10.53.53.163",
  numericIds: "http://10.53.53.163",
} as const;
